<template>
  <div>
    <!-- 使用 Vant 的 van-popup 组件 -->
    <van-popup
      v-model="visible"
      :closeable="closeable"
      :close-icon="closeIcon"
      :overlay="overlay"
      :close-on-click-overlay="false"
      :style="{ width: '100%', height: '100%' }"
      class="custom-popup"
      position="bottom"
    >
      <div class="RechargeCont-cont">
        <div class="d-flex-s">
          <div style="width: 43%; margin-top: 10px">
            <van-icon
              @click="goBack"
              name="arrow-left"
              size="15"
              color="#1F2A47"
            />
          </div>
          <div class="d-flex-s" style="width: 57%">
            <p class="f-t-15 m-t-10">{{ $lang.Depósito }}</p>
            <p @click="goToRechage" class="primary-color f-t-13">
              {{ $lang.RechargeCont_txt }}
            </p>
          </div>
        </div>
        <div class="d-flex" style="border-bottom: 1px solid #cecece">
          <div class="RechargeCont-tab p-r d-flex">
            <img
              class="m-r-10"
              src="../assets/img/recharge/online.png"
              width="20"
            />

            <span class="primary-color f-t-14">{{
              $lang.RechargeCont_txt2
            }}</span>
            <div class="custom-badge">
              <p v-if="lastBonusAmount" class="p-r">
                {{ lastBonusAmount }}
              </p>
              <p class="tool-tips-tail"></p>
            </div>
          </div>
        </div>

        <div class="d-flex m-t-10">
          <div class="type-item d-flex">
            <img src="../assets/img/home/pix-H.png" height="25" class="m-l-5" />
            <span class="primary-color m-l-20">{{ $lang.account }}</span>
            <div class="custom-badge">
              <div v-if="bonusRangeText" class="p-r">
                <p>
                  {{ bonusRangeText }}
                </p>
              </div>
              <p class="tool-tips-tail"></p>
            </div>
            <div class="badgeIcon-c">
              <p class="badgeIcon">
                <van-icon
                  name="success"
                  color="#ffffff"
                  class="badgeIcon-i"
                  size="10"
                />
              </p>
            </div>
          </div>
        </div>
        <p class="p-line"></p>
        <div class="d-flex">
          <div class="type-item d-flex-s t-c">
            <span class="primary-color t-c" style="width: 100%"
              >{{ $lang.account }}1</span
            >
            <div class="badgeIcon-c">
              <p class="badgeIcon">
                <van-icon
                  name="success"
                  color="#ffffff"
                  class="badgeIcon-i"
                  size="10"
                />
              </p>
            </div>
          </div>
        </div>
        <p class="p-line"></p>
        <div v-if="showBg">
          <p class="tipsBox">
            {{ $lang.RechargeCont_txt3 }}
          </p>
          <div class="tipsBox-s">
            <p class="tipsBox-sj"></p>
          </div>
        </div>

        <div class="d-flex-s f-t-13">
          <span>{{ $lang.RechargeCont_txt4 }}</span>
          <span @click="showBg = !showBg" class="primary-color">{{
            $lang.RechargeCont_txt5
          }}</span>
        </div>

        <div class="amount-box-list d-flex-s">
          <div
            class="amount-box-list-item"
            v-for="(item, index) in dataList"
            :key="index"
            :class="{ active: index === selectAmountIndex || item.isActive }"
            @click="selectAmount(index, item)"
          >
            <div
              v-if="(activities.length < 1 || agree) && item.bonus > 0"
              class="custom-badge"
            >
              <div class="p-r">
                <p>
                  {{ $formatNumberWithCommas(item.bonus) }}
                </p>
              </div>
              <p class="tool-tips-tail"></p>
            </div>
            <div class="d-flex-s" style="height: 100%">
              <span style="width: 100%" class="t-c">{{
                $formatNumberWithCommas(item.amount)
              }}</span>
              <div class="badgeIcon-c">
                <p
                  v-if="index === selectAmountIndex || item.isActive"
                  class="badgeIcon"
                >
                  <van-icon
                    name="success"
                    color="#ffffff"
                    class="badgeIcon-i"
                    size="10"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex" v-if="activities.length > 0">
          <van-checkbox
            v-model="agree"
            shape="square"
            checked-color="#666666"
            icon-size="14px"
            style="
              border: 2px solid #666666;
              margin-right: 10px;
              border-radius: 5px;
            "
          ></van-checkbox>
          <p
            v-if="activities[0].code === 'first_recharge_new_1'"
            class="info-color"
          >
            {{ $lang.RechargeCont_txt6 }} {{ getCurrency
            }}{{
              $formatNumberWithCommas(firstBonusAmount) || ''
            }}
          </p>
          <p
            v-if="activities[0].code === 'first_recharge_new_2'"
            class="info-color"
          >
            {{ $lang.RechargeCont_txt7 }}
          </p>
        </div>
        <van-field
          v-model="amount"
          placeholder="Valor da recarga"
          class="custom-field m-t-10"
          type="number"
          :style="{ borderColor: focus ? '#076237' : '#cecece' }"
          @input="handleInput"
          @focus="focus = true"
          @blur="focus = false"
        >
          <template #left-icon>
            <span class="f-t-15">{{ getCurrency }}</span>
          </template>
        </van-field>
        <van-button
          @click="submit"
          size="large"
          class="custom-button m-t-20"
          :class="{ 'active-b': isLoading }"
          :disabled="isLoading"
        >
          {{ $lang.bonus_txt4 }}
        </van-button>
      </div>
    </van-popup>
    <login v-model="showPopup" overlay></login>
  </div>
</template>

<script>
import { Pay, GetIsFbReport, VnRechargeInitS } from '@/api/common'
import {
  buildPayOrderData,
  contentOf,
  defaultAmountIndex,
  failMessage,
  getOrderNo,
  getPaymentUrl,
  hasBlockedPaymentMethods,
  hasLocalToken,
  hasPaymentSuccessProof as paymentFlowHasPaymentSuccessProof,
  hasProvenEmptyPaymentList,
  isNeedLogin,
  isOk,
  isRechargePayReady,
  isUsablePaymentMethod,
  normalizeMoneyAmount,
  normalizeRechargeContent,
  openLogin,
  paymentAmountBounds,
  promoType,
  savePayOrderData,
  showError,
  toNumber
} from '@/components/recharge/paymentFlow'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import { SINGLE_COUNTRY } from '@/config/singleCountry'

function isSafePaymentUrl(url) {
  const value = String(url == null ? '' : url).trim()
  if (!value) return true
  const token = value.toLowerCase()
  if (
    token === '#' ||
    token === 'about:blank' ||
    token === 'javascript:void(0)' ||
    token.startsWith('javascript:') ||
    token.startsWith('vbscript:') ||
    token.startsWith('data:') ||
    token.includes('mock') ||
    token.includes('stub') ||
    token.includes('fallback') ||
    token.includes('read_only') ||
    token.includes('read-only') ||
    token.includes('read only')
  ) return false
  try {
    const parsed = new URL(value)
    return ['http:', 'https:'].includes(parsed.protocol) && Boolean(parsed.hostname)
  } catch (e) {
    return false
  }
}

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) { return null }
  return null
}

function browserWindow() {
  try {
    return typeof window === 'undefined' ? null : window
  } catch (e) {
    return null
  }
}

export default {
  name: 'RechargeCont',
  props: {
    // 控制弹窗显示的布尔值
    value: {
      type: Boolean,
      default: false
    },
    // 是否显示关闭按钮
    closeable: {
      type: Boolean,
      default: false
    },
    // 关闭按钮的图标
    closeIcon: {
      type: String,
      default: 'cross'
    },
    // 是否显示遮罩层
    overlay: {
      type: Boolean,
      default: true
    },
    isFlogin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPopup: false,
      showBg: false,
      isLoading: false,
      agree: false,
      selectIndex: 0,
      selectAmountIndex: null,
      amount: '',
      focus: false,
      dataList: [],
      paymentType: '',
      paymentKey: '',
      paymentId: '',
      rechargeFees: 0,
      visible: this.value, // 内部状态
      paymentList: [],
      activities: [],
      firstRecharge: false
    }
  },

  watch: {
    // 监听外部传入的 value 值变化
    value(newVal) {
      this.visible = newVal
    },
    // 监听内部 visible 值变化，同步到外部
    visible(newVal) {
      this.$emit('input', newVal)
    },
    paymentList: {
      deep: true, // 开启深度监听
      // immediate: true, // 在加载时立即调用一次
      handler() {
        if (this.paymentList.length < 1) return
        this.tabIndex(0)
        const selectedIndex = defaultAmountIndex(this.paymentList[0].quickSelect)
        if (selectedIndex >= 0) {
          this.selectAmount(selectedIndex, this.paymentList[0].quickSelect[selectedIndex])
          this.amount = this.paymentList[0].quickSelect[selectedIndex].amount
        }
        this.agree = true
      }
    }
  },
  computed: {
    firstQuickSelect() {
      return this.paymentList.length > 0 && Array.isArray(this.paymentList[0].quickSelect)
        ? this.paymentList[0].quickSelect
        : []
    },
    lastBonusAmount() {
      const lastItem = this.firstQuickSelect[this.firstQuickSelect.length - 1]
      return lastItem ? toNumber(lastItem.bonus, 0) : 0
    },
    firstBonusAmount() {
      const matched = this.dataList.find((item) => toNumber(item.bonus, 0) > 0)
      return matched ? toNumber(matched.bonus, 0) : 0
    },
    bonusRangeText() {
      if (this.firstQuickSelect.length < 1) return ''
      const firstBonus = this.firstQuickSelect.length > 1
        ? toNumber(this.firstQuickSelect[1].bonus, 0)
        : toNumber(this.firstQuickSelect[0].bonus, 0)
      const lastBonus = this.lastBonusAmount
      if (!firstBonus && !lastBonus) return ''
      return `${firstBonus}-${lastBonus}`
    }
  },
  mounted() {
    if (hasLocalToken(this)) {
      this.VnRechargeInitS()
    } else {
      openLogin(this)
    }
  },
  methods: {
    goToRechage() {
      this.$jumpTo('/recordOrder')
    },
    goBack() {
      this.visible = false
    },
    async VnRechargeInitS() {
      try {
        const data = await VnRechargeInitS()
        if (isOk(data)) {
          const rawContent = contentOf(data)
          const rawPaymentList = Array.isArray(rawContent.paymentList) ? rawContent.paymentList : []
          const provenEmptyPaymentList = typeof hasProvenEmptyPaymentList === 'function' && hasProvenEmptyPaymentList(data, rawPaymentList)
          const content = normalizeRechargeContent(rawContent)
          this.paymentList = content.paymentList
          this.dataList = content.paymentList.length > 0 ? content.paymentList[0].quickSelect : []
          this.activities = content.activities
          this.firstRecharge = content.firstRecharge
          if (!content.paymentList.length && !provenEmptyPaymentList && (!rawPaymentList.length || hasBlockedPaymentMethods(rawPaymentList))) {
            this.$toast({
              message: this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.',
              icon: 'cross'
            })
          }
        } else {
          showError(this, data)
        }
      } catch (e) {
        showError(this)
      }
    },
    async GetIsFbReport(v) {
      const storage = getLocalStorage()
      try {
        const data = await GetIsFbReport({
          inviteCode: safeGetStorageItem(storage, 'id')
        })
        if (isOk(data)) {
          const content = contentOf(data)
          const reportValue = parseInt(toNumber(v, 0) * 0.1)
          // 运行时币种派生:优先真实币种,回退单国币种,最终兜底 XOF(原写死 NGN/BRLS)
          const reportCurrency = this.getCurrency || (SINGLE_COUNTRY && SINGLE_COUNTRY.currency) || 'XOF'
          if (content.isReport && reportValue > 0) {
            const win = browserWindow()
            const kwaiq = win && win.kwaiq
            if (
              content.target === 'ks' &&
              kwaiq &&
              typeof kwaiq.load === 'function' &&
              typeof kwaiq.instance === 'function' &&
              content.fbPixId
            ) {
              kwaiq.load(content.fbPixId)
              const tracker = kwaiq.instance(content.fbPixId)
              if (tracker && typeof tracker.track === 'function') {
                tracker.track('addToCart', {
                  value: reportValue,
                  currency: reportCurrency
                })
              }
            } else if (this.$pixel && content.fbPixId) {
              const pixel = this.$pixel
              if (typeof pixel.setFbId === 'function') {
                pixel.setFbId(content.fbPixId)
              }
              if (typeof pixel.callTrackHasPara === 'function') {
                pixel.callTrackHasPara('track', 'AddToCart', reportValue, reportCurrency)
              }
              const jsonData = `"""{"data":[{"event_name": "Lead","content_name": "Recharge Form","value": ${reportValue},"currency": "${reportCurrency}"}]}"""`
              if (typeof pixel.sendEventToAndroid === 'function') {
                pixel.sendEventToAndroid(jsonData)
              }
            }
          }
        }
      } catch (e) {
        // Tracking failures must not block recharge.
      }
    },
    hasPaymentSuccessProof(res) {
      return paymentFlowHasPaymentSuccessProof(res)
    },
    async submit() {
      if (this.isLoading) return
      if (!hasLocalToken(this)) {
        openLogin(this)
        return
      }
      const selectedPayment = this.paymentList[this.selectIndex]
      const bounds = paymentAmountBounds(selectedPayment)
      const amountCheck = normalizeMoneyAmount(this.amount, bounds)
      if (!isUsablePaymentMethod(selectedPayment) || !this.paymentId) {
        this.$toast({
          message: this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.',
          icon: 'cross'
        })
        return
      }
      if (!amountCheck.ok) {
        this.$toast({
          message: this.$lang.RechargeCont_txt8,
          icon: 'cross'
        })
        return
      }
      this.isLoading = true
      try {
        const data = await Pay({
          paymentAmount: amountCheck.amount,
          paymentId: this.paymentId,
          paymentKey: this.paymentKey,
          paymentType: this.paymentType,
          rechargeFees: this.rechargeFees,
          promoType: promoType(this.firstRecharge, this.activities, this.agree)
        })
        if (isRechargePayReady(data)) {
          if (!this.hasPaymentSuccessProof(data)) {
            this.$toast({
              message: failMessage(data, this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.'),
              icon: 'cross'
            })
            return
          }
          const content = contentOf(data)
          const paymentUrl = getPaymentUrl(content)
          const orderNo = getOrderNo(content)
          if (!paymentUrl && !orderNo) {
            this.$toast({
              message: failMessage(data, this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.'),
              icon: 'cross'
            })
            return
          }
          if (!isSafePaymentUrl(paymentUrl)) {
            this.$toast({
              message: failMessage(data, this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.'),
              icon: 'cross'
            })
            return
          }

          this.GetIsFbReport(amountCheck.amount)
          if (this.paymentKey === 'usdt') {
            const orderData = buildPayOrderData(content, {
              paymentAmount: amountCheck.amount,
              paymentId: this.paymentId,
              paymentKey: this.paymentKey
            })
            if (!savePayOrderData(orderData)) {
              this.$toast({
                message: this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.',
                icon: 'cross'
              })
              return
            }
            this.$jumpTo('/payOrder')
          } else if (paymentUrl) {
            // #4:支付网关 URL 存 sessionStorage(不放进可被构造的路由 query)→ 切断反射钓鱼。
            try { window.sessionStorage.setItem('gameHallFrameUrl:recharge', paymentUrl) } catch (e) { /* sessionStorage 不可用时静默,不阻断跳转 */ }
            this.$jumpTo('/gameHall', {
              from: 'recharge'
            })
          }
        } else if (isOk(data)) {
          this.$toast({
            message: failMessage(data, this.$lang.feature_unavailable || 'This payment channel is temporarily unavailable. Please try again later.'),
            icon: 'cross'
          })
        } else if (isNeedLogin(data)) {
          openLogin(this)
        } else {
          showError(this, data)
        }
      } catch (e) {
        showError(this)
      } finally {
        this.isLoading = false
      }
    },
    tabIndex(i) {
      const payment = this.paymentList[i]
      if (!payment) return
      const paymentId = payment.paymentId || payment.payment_id || payment.channelId || payment.channel_id || payment.payChannelId || payment.pay_channel_id || payment.methodId || payment.method_id || payment.id || ''
      const paymentKey = payment.paymentKey || payment.payment_key || payment.channelKey || payment.channel_key || payment.channelCode || payment.channel_code || payment.methodKey || payment.method_key || payment.payKey || payment.pay_key || payment.key || payment.code || paymentId
      this.selectIndex = i
      this.dataList = Array.isArray(payment.quickSelect) ? payment.quickSelect : []
      this.dataList.forEach((i) => {
        i.isActive = false
      })
      this.paymentId = paymentId
      this.paymentKey = String(paymentKey || '').toLowerCase()
      this.paymentType = payment.paymentType
      this.rechargeFees = toNumber(payment.rechargeFees, 0)
    },
    selectAmount(i, v) {
      if (!v) return
      this.dataList.forEach((i) => {
        i.isActive = false
      })
      this.selectAmountIndex = i
      this.amount = v.amount
    },
    handleInput(i) {
      // 根据输入框的值更新按钮的激活状态
      this.dataList.forEach((item) => {
        item.isActive = toNumber(item.amount, 0) === toNumber(i, 0)
        this.selectAmountIndex = null
      })
    }
  }
}
</script>

<style lang="less" scoped>
.custom-popup {
  border-radius: 15px 15px 0 0;
  // height: 90%;
  padding-bottom: 30px;
  .RechargeCont-cont {
    padding: 10px;
  }
  .type-item {
    width: 120px;
    position: relative;
    border-radius: 5px;
    border: 1px solid @brand;
    height: 40px;
  }
  ::v-deep .van-checkbox__icon .van-icon {
    border: none;
  }
  ::v-deep .van-checkbox__icon--checked .van-icon {
    background-color: transparent !important;
    color: #333333;
  }
}
.custom-badge {
  position: absolute;
  right: -10px;
  top: -7px;
  font-size: 9px;
  color: #ffffff;
  background: #ea4e3d;
  border-radius: 15px 15px 15px 0;
  padding: 2px 3px;
  min-width: 28px;
  text-align: center;
}
.tool-tips-tail {
  position: absolute;
  top: 13px;
  left: 0;
  width: 0;
  height: 0;
  border-left: 0px solid transparent; /* 左边框透明 */
  border-right: 5px solid transparent; /* 右边框透明 */
  border-top: 6px solid #ea4e3d; /* 上边框设置颜色和宽度 */
}
.RechargeCont-tab {
  margin-top: 30px;
  border-bottom: 2px solid @brand;
  padding-bottom: 5px;
}
.badgeIcon-c {
  position: absolute;
  top: 22px;
  right: 0;
}
.badgeIcon {
  position: relative;
  border-left: 16px solid transparent !important;
  // border-right: 0px solid transparent !important;
  border-bottom: 16px solid @brand;
  // border-radius: 0 0 3px 0;
}
.badgeIcon-i {
  position: absolute;
  right: 0;
  top: 6px;
  width: 10px;
}
.p-line {
  height: 1px;
  background: #cecece;
  margin: 10px 0 15px 0;
}
.tipsBox {
  border-radius: 5px;
  padding: 10px;
  text-align: center;
  background: fade(@info-color, 14%); /* 浅金底(原实金底白字对比不足 ~1.9:1) */
  color: @info-color; /* 金字(铁律②:信息提示=金,WCAG 可读) */
  border: 1px solid fade(@info-color, 35%);
}
.tipsBox-sj {
  width: 10px;
  border-left: 5px solid transparent; /* 左边框透明 */
  border-right: 5px solid transparent; /* 右边框透明 */
  border-top: 6px solid @info-color; /* 上边框设置颜色和宽度 */
  margin-right: 30px;
  margin-bottom: 2px;
}
.tipsBox-s {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.amount-box-list {
  flex-flow: wrap row;
  margin-top: 15px;
}
.amount-box-list-item {
  position: relative;
  border-radius: 5px;
  border: 1px solid #cecece;
  width: 22%;
  height: 40px;
  margin-bottom: 10px;
}
.active {
  border: 1px solid @brand;
}
</style>
